import { useContext, useState } from 'react'

import { TitleContext } from '@providers/TitleProvider'
import UserService from '@services/UserService'
import { useSession } from '@stores/globalData/globalData.store'

/**
 * Contains logic to facilitate the follow user link
 */
const useFollowLink = () => {
  const {
    title: { seller },
    updateTitle,
  } = useContext(TitleContext)
  const session = useSession()
  const [loading, setLoading] = useState(false)

  const toggleFollowing = async (): Promise<void> => {
    if (!seller) return

    setLoading(true)
    const following = seller.following

    // Optimistically show success (quicker UI response)
    updateTitle({ seller: { ...seller, following: !following } })

    const success = following
      ? await UserService.unfollow(seller.id)
      : await UserService.follow(seller.id)
    if (success) {
      // Perform local state update
      updateTitle({
        seller: {
          ...seller,
          following: !following,
          follower_count: following ? seller.follower_count - 1 : seller.follower_count + 1,
        },
      })
    } else {
      // Undo optimistic state change
      updateTitle({ seller: { ...seller, following: following } })
    }

    setLoading(false)
  }

  const canFollowSeller = (): boolean => {
    return (
      !!seller &&
      session.isDefaultCommunity() &&
      session.isLoggedIn() &&
      session.currentUser?.external_id !== seller?.id
    )
  }

  return { loading, following: seller?.following ?? false, canFollowSeller, toggleFollowing }
}

export default useFollowLink
